// extracted by mini-css-extract-plugin
export default {"getOutline":"ScrollToTop_getOutline__E7lUP","ScrollToTop":"ScrollToTop_ScrollToTop__UciAu","Visible":"ScrollToTop_Visible__2nZjf"};